import React from 'react';

interface CompletionProgressBarProps {
  percentage: number; // Percentage from 0 to 100
  className?: string;
  showLabel?: boolean; // Whether to show the label below the progress bar
}

const CompletionProgressBar: React.FC<CompletionProgressBarProps> = ({
  percentage,
  className = '',
}) => {
  return (
    <div className={`w-full ${className}`}>
      {/* Progress bar container */}
      <div className="relative w-full bg-gray-200 rounded-full h-10 border-2 border-gray-400 overflow-hidden">
        {/* Progress bar fill */}
        <div
          className="h-full transition-all duration-1000 ease-out"
          style={{
            width: `${Math.max(percentage, 10)}%`, // Minimum 10% width for visibility
            backgroundColor:
              percentage >= 50
                ? 'rgba(16, 185, 129, 0.7)'
                : percentage >= 30
                ? 'rgba(245, 158, 11, 0.7)'
                : 'rgba(239, 68, 68, 0.7)', // Transparent colors
            minWidth: '20px', // Ensure minimum visible width
            borderRadius: 'inherit', // Inherit the same border radius as container
          }}
        />

        {/* Percentage text overlay */}
        <div className="absolute inset-0 flex items-center justify-center">
          <span className="text-sm font-semibold text-gray-800">
            {percentage.toFixed(0)}%
          </span>
        </div>
      </div>
    </div>
  );
};

export default CompletionProgressBar;
